import React, { useState, useEffect } from "react";
import { Col, Modal, ModalBody, ModalFooter, ModalHeader, Label, Input, Row } from "reactstrap";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";

import {
listFamilyByParams,
createFamily,
updateFamily,
deleteFamily,
getFamilyById,
mainCategoryDropdown
} from "../../api/family.api";

import StatusBadge from "../../components/StatusBadge";

const FamilyMaster = () => {

const initialState = {
family_name:"",
main_category_id:"",
sequence:"",
is_active:true
};

const [values,setValues] = useState(initialState);
const [data,setData] = useState([]);
const [categories,setCategories] = useState([]);

const [loading,setLoading] = useState(false);
const [query,setQuery] = useState("");
const [filter,setFilter] = useState(true);

const [modal_add,setModalAdd] = useState(false);
const [modal_edit,setModalEdit] = useState(false);
const [modal_delete,setModalDelete] = useState(false);

const [_id,set_Id] = useState("");
const [remove_id,setRemove_id] = useState("");

const [pageNo,setPageNo] = useState(1);
const [perPage,setPerPage] = useState(10);
const [totalRows,setTotalRows] = useState(0);



const fetchData = async()=>{

setLoading(true);

const skip = (pageNo-1)*perPage;

const res = await listFamilyByParams({
skip,
per_page:perPage,
match:query,
is_active:filter
});

if(res.data.data.length>0){
const result = res.data.data[0];
setData(result.data);
setTotalRows(result.count);
}else{
setData([]);
}

setLoading(false);

};



useEffect(()=>{

mainCategoryDropdown()
.then(res=>setCategories(res.data.data||[]));

fetchData();

},[query,pageNo,perPage,filter]);



const handleAdd = async(e)=>{

e.preventDefault();

await createFamily(values);

toast.success("Family Added");

setModalAdd(false);
setValues(initialState);

fetchData();

};



const handleEdit = async(id)=>{

set_Id(id);

const res = await getFamilyById(id);

setValues(res.data.data);

setModalEdit(true);

};



const handleUpdate = async(e)=>{

e.preventDefault();

await updateFamily(_id,values);

toast.success("Updated Successfully");

setModalEdit(false);
setValues(initialState);

fetchData();

};



const handleDelete = async()=>{

await deleteFamily(remove_id);

toast.success("Deleted");

setModalDelete(false);

fetchData();

};



const columns=[

{ name:"Sr No", selector:(r,i)=>i+1, width:"80px" },

{ name:"Family Name", selector:r=>r.family_name, grow:2, style:{fontWeight:"600"} },

{ name:"Category", selector:r=>r.category_name },

{ name:"Seq", selector:r=>r.sequence, center:true },

{
    name:"Status",
    center:true,
    cell:(r)=>(
        <StatusBadge status={r.is_active ? "ACTIVE" : "INACTIVE"} />
    )
},

{
name:"Actions",
right:true,
cell:(row)=>(
<div className="d-flex gap-3">

<button
className="btn btn-link p-0 text-muted"
onClick={()=>handleEdit(row.id)}
>
🖊️
</button>

<button
className="btn btn-link p-0 text-danger"
onClick={()=>{setRemove_id(row.id);setModalDelete(true)}}
>
🗑️
</button>

</div>
)
}

];



return(

<div style={{ backgroundColor:"#ffffff",padding:"clamp(15px, 3vw, 24px)",borderRadius:"12px",border:"1px solid #e5e7eb" }}>

<div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-3">

<div>
<h4 className="fw-bold m-0" style={{color:"#112347"}}>Category Family Management</h4>
<p className="text-muted small m-0">Organize Product Families</p>
</div>

<button
className="btn btn-dark fw-bold px-4 py-2"
style={{ backgroundColor:"#112347",borderRadius:"8px"}}
onClick={()=>{setValues(initialState);setModalAdd(true)}}
>
+ Add Family
</button>

</div>



<Row className="mb-4 align-items-center g-3">

<Col md="4" xs="12" className="position-relative">

<span className="position-absolute translate-middle-y top-50 ms-3 text-muted">🔍</span>

<Input
placeholder="Search Family..."
value={query}
onChange={(e)=>setQuery(e.target.value)}
style={{ backgroundColor:"#f9fafb",border:"1px solid #e5e7eb",borderRadius:"8px",paddingLeft:"40px"}}
/>

</Col>

<Col md="3" xs="12">

<div className="form-check">

<Input
type="checkbox"
checked={filter}
onChange={(e)=>setFilter(e.target.checked)}
/>

<Label className="ms-2">Show Active Only</Label>

</div>

</Col>

</Row>



<div className="table-responsive border rounded-3 overflow-hidden">

<DataTable
columns={columns}
data={data}
progressPending={loading}
pagination
paginationServer
paginationTotalRows={totalRows}
onChangePage={setPageNo}
onChangeRowsPerPage={setPerPage}
/>

</div>



{/* ADD MODAL */}

<Modal isOpen={modal_add} toggle={()=>setModalAdd(false)} centered>

<ModalHeader>Add Family</ModalHeader>

<ModalBody>

<Label>Family Name</Label>

<Input
value={values.family_name}
onChange={(e)=>setValues({...values,family_name:e.target.value})}
/>

<Label className="mt-2">Category</Label>

<Input
type="select"
value={values.main_category_id}
onChange={(e)=>setValues({...values,main_category_id:e.target.value})}
>

<option value="">Select</option>

{categories.map(c=>(
<option key={c.id} value={c.id}>{c.category_name}</option>
))}

</Input>

<Label className="mt-2">Sequence</Label>

<Input
type="number"
value={values.sequence}
onChange={(e)=>setValues({...values,sequence:e.target.value})}
/>

<Label className="mt-3">Active</Label>

<div className="form-check">

<Input
type="checkbox"
checked={values.is_active}
onChange={(e)=>setValues({...values,is_active:e.target.checked})}
/>

<Label className="ms-2">Is Active</Label>

</div>

</ModalBody>

<ModalFooter>

<button
className="btn btn-dark w-100"
style={{backgroundColor:"#112347"}}
onClick={handleAdd}
>
Save Family
</button>

</ModalFooter>

</Modal>



{/* EDIT MODAL */}

<Modal isOpen={modal_edit} toggle={()=>setModalEdit(false)} centered>

<ModalHeader>Edit Family</ModalHeader>

<ModalBody>

<Label>Family Name</Label>

<Input
value={values.family_name}
onChange={(e)=>setValues({...values,family_name:e.target.value})}
/>

<Label className="mt-2">Category</Label>

<Input
type="select"
value={values.main_category_id}
onChange={(e)=>setValues({...values,main_category_id:e.target.value})}
>

<option value="">Select</option>

{categories.map(c=>(
<option key={c.id} value={c.id}>{c.category_name}</option>
))}

</Input>

<Label className="mt-2">Sequence</Label>

<Input
type="number"
value={values.sequence}
onChange={(e)=>setValues({...values,sequence:e.target.value})}
/>

<Label className="mt-3">Active</Label>

<div className="form-check">

<Input
type="checkbox"
checked={values.is_active}
onChange={(e)=>setValues({...values,is_active:e.target.checked})}
/>

<Label className="ms-2">Is Active</Label>

</div>

</ModalBody>

<ModalFooter>

<button
className="btn btn-dark w-100"
style={{backgroundColor:"#112347"}}
onClick={handleUpdate}
>
Update Family
</button>

</ModalFooter>

</Modal>



{/* DELETE MODAL */}

<Modal isOpen={modal_delete} toggle={()=>setModalDelete(false)} centered>

<ModalHeader>Delete Family</ModalHeader>

<ModalBody>
Are you sure you want to delete this family?
</ModalBody>

<ModalFooter>

<button className="btn btn-danger" onClick={handleDelete}>
Delete
</button>

</ModalFooter>

</Modal>

</div>

);

};

export default FamilyMaster;